import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "../../styles/homepage/UsInAction.css";

function UsInAction() {
  const [offset, setOffset] = useState(0);

  const initiatives = [
    {
      id: 1,
      initiative_image: "/images/team-in-action-images/KindaTech-Launch.png",
      initiative_title: "Empowering SMEs in Zambia: The Launch of Kinda-Tech ERP Systems",
      initiative_description: "Signifide Group International Limited (SGIL), in conjunction with Financial Insights Zambia (FIZ), orchestrated the InvestLink & Kinda-Tech ERP launch event."
    },
    {
      id: 2,
      initiative_image: "/images/team-in-action-images/Investment-summit.png",
      initiative_title: "The Zambia Impact Investment Summit 2023 - September 12-13",
      initiative_description: "Signifide Group featured at ZIIS23, highlighting the growing role of digital infrastructure in Zambia’s investment landscape."
    },
    {
      id: 3,
      initiative_image: "/images/team-in-action-images/WEAC-Signing.png",
      initiative_title: "Signifide Group and Women's Entrepreneurship Access Centre (WEAC) Form Strategic Partnership",
      initiative_description: "Signifide Group and WEAC made it official! On November 23, 2023, they signed an MOU to drive innovation, empowerment, and business growth."
    },
    {
      id: 4,
      initiative_image: "/images/team-in-action-images/SME-Event.png",
      initiative_title: "SME Investment Expo 2024",
      initiative_description: "At the SME Investment Expo 2024 on October 31st, Signifide Group showcased KindaTrade, KindaTech, and KindaGigz, joining industry leaders to unlock financial investment opportunities for SMEs."
    },
    {
      id: 5,
      initiative_image: "/images/team-in-action-images/KindaTrade-local-vendors.jpeg",
      initiative_title: "Empowering Local Vendors with Digital Solutions - Kinda Trade",
      initiative_description: "On April 13, 2024, our team hit the ground at Toi Market (Adams Arcade) for a market activation event, engaging 25 local traders, including mama mbogas, riders, and vendors."
    }
  ];

  const cardWidth = 320;
  const maxOffset = (initiatives.length - 2) * cardWidth;

  const handleSwipeLeft = () => {
    setOffset((prevOffset) => Math.min(prevOffset + cardWidth, maxOffset));
  };

  const handleSwipeRight = () => {
    setOffset((prevOffset) => Math.max(prevOffset - cardWidth, 0));
  };

  return (
    <div className="us-in-action-component">
      <h2>Our Team in Action</h2>

      <div className="swipe-buttons">
        <button onClick={handleSwipeRight} disabled={offset === 0}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button onClick={handleSwipeLeft} disabled={offset >= maxOffset}>
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      <div
        className="in-action-container"
        style={{
          transform: `translateX(-${offset}px)`,
          transition: "transform 0.5s ease",
        }}
      >
        {initiatives.map((initiative) => (
          <div key={initiative.id} className="action-card">
            <img
              src={initiative.initiative_image}
              alt={initiative.initiative_title}
            />
            <div className="action-description">
              <h5>{initiative.initiative_title}</h5>
              <p>{initiative.initiative_description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UsInAction;
